import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlideWideAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSlideWideAdd"><Path fillRule="evenodd" clipRule="evenodd" d="M2 20V4H22V20H2ZM12.75 8H11.25V11.25H8V12.75H11.25V16H12.75V12.75H16V11.25H12.75V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSlideWideAdd;
